import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./ContactCards.module.css";
import callImg from "../../assets/Contact/call.png";
import locImg from "../../assets/Contact/loc.png";
import emailImg from "../../assets/Contact/email.png";
const ContactCards = () => {
  return (
    <div className={styles.wrapper}>
      <Container>
        <Row>
          <Col md={4}>
            <div className={styles.crd}>
              <div className="d-flex  flex-column justify-content-center align-items-center">
                <img src={emailImg} className={styles.icon} alt="" />
                <span className={`d-block pt-3 ${styles.heading}`}>
                  Email us
                </span>
              </div>
              <span className={`d-block ${styles.subheading}`}>
                if you need our help,have questions about how to use the
                platform or are{" "}
              </span>
              <span className={`d-block ${styles.text}`}>
                technowrenltd@gmail.com
              </span>
            </div>
          </Col>
          <Col md={4}>
            <div className={styles.crd}>
              <div className="d-flex  flex-column justify-content-center align-items-center">
                <img src={callImg} className={styles.icon} alt="" />
                <span className={`d-block pt-3 ${styles.heading}`}>
                  Call Us
                </span>
              </div>
              <span className={`d-block ${styles.subheading}`}>
                if you need our help,have questions about how to use the
                platform or are
              </span>
              <span className={`d-block ${styles.text}`}>+8801677482932</span>
            </div>
          </Col>
          <Col md={4}>
            <div className={styles.crd}>
              <div className="d-flex  flex-column justify-content-center align-items-center">
                <img src={locImg} className={styles.icon} alt="" />
                <span className={`d-block pt-3 ${styles.heading}`}>
                  Reach Us
                </span>
              </div>
              <span className={`d-block ${styles.subheading}`}>
                Northern, Talaimary
                <br />
                <br />
              </span>
              <span className={`d-block ${styles.text}`}>
                Rajshahi,Bangladesh
              </span>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactCards;
